import { useState } from 'react'

export type UseDialogReturnType<T> = [
  isDialogOpen: boolean,
  openDialog: (data: T) => void,
  closeDialog: () => void,
  dialogData: T
]

export type UseDialogOptionalReturnType<T> = [
  isDialogOpen: boolean,
  openDialog: (data?: T) => void,
  closeDialog: () => void,
  dialogData: T | undefined
]

export default function useDialog<T>(
  initialDialogData: T
): UseDialogReturnType<T>
export default function useDialog<T = undefined>(
  initialDialogData?: T
): UseDialogOptionalReturnType<T>

export default function useDialog<T>(initialDialogData?: T) {
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [dialogData, setDialogData] = useState<T | undefined>(initialDialogData)

  const openDialog = (data?: T) => {
    setDialogData(data)
    setIsDialogOpen(true)
  }
  const closeDialog = () => setIsDialogOpen(false)

  return [isDialogOpen, openDialog, closeDialog, dialogData] as const
}
